export class Streets {
  private constructor(
    public readonly streets: string[],
    public filteredStreets: string[]
  ) {}

  static empty(): Streets {
    return new Streets([], []);
  }

  static of(streets: string[]): Streets {
    return new Streets(streets, streets);
  }

  find(street: string): string | null {
    return this.streets.find((s) => s === street);
  }

  filter(street: string): void {
    const lowerCaseStreet = street.toLowerCase();
    this.filteredStreets = this.streets.filter(
      (s) => s.toLowerCase().indexOf(lowerCaseStreet) !== -1
    );
  }

  firstIfSingle(): string | null {
    return this.streets.length === 1 ? this.streets[0] : null;
  }
}
